import { cn } from '@/lib/utils'

/**
 * Toggle switch — supports both `on` (legacy) and `checked` prop names.
 * onChange receives the new boolean value.
 */
export function Toggle({ on, checked, onChange, disabled = false }) {
  const isOn = on ?? checked ?? false

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isOn}
      disabled={disabled}
      onClick={() => !disabled && onChange?.(!isOn)}
      className={cn(
        'relative h-[22px] w-10 rounded-full flex-shrink-0 transition-colors duration-200',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/40',
        isOn ? 'bg-accent' : 'bg-surface-raised border border-border',
        disabled ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer'
      )}
    >
      <span
        className="absolute top-1/2 left-0 h-[18px] w-[18px] rounded-full bg-white shadow-sm pointer-events-none"
        style={{
          transform: isOn ? 'translateX(20px) translateY(-50%)' : 'translateX(2px) translateY(-50%)',
          transition: 'transform 180ms cubic-bezier(0.23, 1, 0.32, 1)',
        }}
      />
    </button>
  )
}
